export type AdditionalFieldsClassProps = {
    new_user: string;
    project_name?: string;
};

export default class AdditionalFields {
    public readonly newUser: boolean;
    public readonly projectName?: string;

    constructor(props: AdditionalFieldsClassProps) {
        if (props) {
            this.newUser = props.new_user ? JSON.parse(props.new_user) : false;
            this.projectName = props.project_name;
        } else {
            this.newUser = false;
        }
    }
}
